import { Breadcrumbs, Card, Grid, Typography } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";

const useStyles = makeStyles((theme) => ({
	title: {
		margin: theme.spacing(1, 0),
	},
}));

const TableOnPriority = (props) => {
	const classes = useStyles();

	const { getDataTables, BaseUrl, tableRef, pageSize, modalEdit } = props;

	const columns = [
		{ title: "Name", field: "nama" },
		{ title: "Description", field: "deskripsi" },
		{ title: "Reducetime %", field: "reducetime" },
	];
	return (
		<Grid
			item
			direction="column-reverse"
			justifyContent="space-between"
			alignItems="stretch"
		>
			<Grid item>
				<Card className={classes.title}>
					<Breadcrumbs aria-label="breadcrumb" style={{ padding: "10px" }}>
						<Typography color="textPrimary" style={{ padding: "10px" }}>
							Dashboard
						</Typography>
						<Typography color="textPrimary" variant="h6">
							List Priority
						</Typography>
					</Breadcrumbs>
				</Card>

				<div style={{ marginTop: "20px" }}>
					<MaterialTable
						title="List Priority"
						tableRef={tableRef}
						columns={columns}
						data={getDataTables({ url: `${BaseUrl}` })}
						actions={[
							{
								icon: "edit",
								tooltip: "Edit",
								iconProps: { style: { fontSize: "20px", color: "green" } },
								onClick: (evt, rowData) => modalEdit(rowData),
							},
						]}
						options={{
							search: false,
							actionsColumnIndex: -1,
							paginationType: "stepped",
							pageSize: pageSize,
							pageSizeOptions: [5, 10, 50, 100],
							headerStyle: {
								backgroundColor: "#67A3D5",
								color: "#FFF",
							},
						}}
					/>
				</div>
			</Grid>
		</Grid>
	);
};

export default TableOnPriority;
